export default __webpack_public_path__ + "static/media/menu_rooms_selected.15232a16.svg";